export default {
    APPLY_COHORT: 'APPLY_COHORT',
    MARK_CONTRACT_ISSUED: 'MARK_CONTRACT_ISSUED',
    MARK_COMPLETED: 'MARK_COMPLETED',
    DELETE_COHORT: 'DELETE_COHORT',
};
